(function () {
  'use strict';

  if (window.__rnrSearchaniseSwatchesLoaded) return;
  window.__rnrSearchaniseSwatchesLoaded = true;

  var VISUAL_OPTION_NAMES = ['color', 'colour', 'finish', 'fabric', 'upholstery'];
  var MAX_VISIBLE_SWATCHES = 6;
  var CACHE_PREFIX = 'rnr-snize-swatches-v1:';
  var memoryCache = new Map();
  var pendingRequests = new Map();
  var observer = null;
  var scanTimer = null;

  function normalizeOptionName(name) {
    return String(name || '').trim().toLowerCase();
  }

  function isVisualOption(name) {
    var normalized = normalizeOptionName(name);
    return VISUAL_OPTION_NAMES.some(function (candidate) {
      return normalized === candidate || normalized.indexOf(candidate) !== -1;
    });
  }

  function getShopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function getProductHandle(card) {
    var link = card.querySelector('a.snize-view-link[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  }

  function getProductUrl(card, product, handle) {
    var link = card.querySelector('a.snize-view-link[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (link && link.getAttribute('href')) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        return url.pathname;
      } catch (error) {
        // Use the Ajax product URL fallback below.
      }
    }
    if (product && product.url) return product.url;
    return getShopRoot() + 'products/' + encodeURIComponent(handle);
  }

  function getVariantValue(variant, optionPosition) {
    var index = optionPosition - 1;
    if (variant && Array.isArray(variant.options) && typeof variant.options[index] !== 'undefined') {
      return variant.options[index];
    }
    return variant ? variant['option' + optionPosition] : null;
  }

  function getVariantImage(variant, product) {
    var image = variant && variant.featured_image;
    if (typeof image === 'string') return image;
    if (image && image.src) return image.src;
    if (image && image.url) return image.url;

    var media = variant && variant.featured_media;
    if (media && media.preview_image && media.preview_image.src) return media.preview_image.src;
    if (media && media.preview_image && media.preview_image.url) return media.preview_image.url;

    if (product && Array.isArray(product.images) && variant && variant.image_id) {
      for (var i = 0; i < product.images.length; i += 1) {
        var productImage = product.images[i];
        if (productImage && typeof productImage === 'object' && String(productImage.id) === String(variant.image_id)) {
          return productImage.src || productImage.url || null;
        }
      }
    }

    if (product && typeof product.featured_image === 'string') return product.featured_image;
    if (product && product.featured_image && product.featured_image.src) return product.featured_image.src;
    return null;
  }

  function compactProductData(product, handle) {
    if (!product || !Array.isArray(product.variants) || !Array.isArray(product.options)) return null;

    var visualOption = null;
    for (var i = 0; i < product.options.length; i += 1) {
      var option = product.options[i];
      var optionName = typeof option === 'string' ? option : option && option.name;
      var optionPosition = typeof option === 'object' && option.position ? option.position : i + 1;
      if (isVisualOption(optionName)) {
        visualOption = { name: optionName, position: optionPosition };
        break;
      }
    }

    if (!visualOption) return null;

    var values = new Map();
    var selectedVariant = null;

    product.variants.forEach(function (variant) {
      var value = getVariantValue(variant, visualOption.position);
      if (!value) return;

      if (!selectedVariant && variant.available) selectedVariant = variant;

      var key = String(value);
      var current = values.get(key);
      if (!current) {
        current = {
          value: key,
          variantId: variant.id,
          available: Boolean(variant.available),
          image: getVariantImage(variant, product)
        };
        values.set(key, current);
      } else if (!current.available && variant.available) {
        current.variantId = variant.id;
        current.available = true;
        current.image = getVariantImage(variant, product) || current.image;
      } else if (!current.image) {
        current.image = getVariantImage(variant, product);
      }
    });

    var swatches = Array.from(values.values()).filter(function (item) {
      return item.available;
    });

    if (swatches.length < 2) return null;

    if (!selectedVariant) {
      selectedVariant = product.variants[0] || null;
    }

    return {
      handle: handle,
      optionName: visualOption.name,
      selectedValue: selectedVariant ? String(getVariantValue(selectedVariant, visualOption.position) || '') : '',
      url: product.url || getShopRoot() + 'products/' + encodeURIComponent(handle),
      swatches: swatches
    };
  }

  function readSessionCache(handle) {
    try {
      var value = window.sessionStorage.getItem(CACHE_PREFIX + handle);
      return value ? JSON.parse(value) : undefined;
    } catch (error) {
      return undefined;
    }
  }

  function writeSessionCache(handle, value) {
    try {
      window.sessionStorage.setItem(CACHE_PREFIX + handle, JSON.stringify(value));
    } catch (error) {
      // Storage can be unavailable in private browsing or restricted contexts.
    }
  }

  function loadProductSwatches(handle) {
    if (memoryCache.has(handle)) return Promise.resolve(memoryCache.get(handle));
    if (pendingRequests.has(handle)) return pendingRequests.get(handle);

    var stored = readSessionCache(handle);
    if (typeof stored !== 'undefined') {
      memoryCache.set(handle, stored);
      return Promise.resolve(stored);
    }

    var request = fetch(getShopRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product data request failed');
        return response.json();
      })
      .then(function (product) {
        var compact = compactProductData(product, handle);
        memoryCache.set(handle, compact);
        writeSessionCache(handle, compact);
        return compact;
      })
      .catch(function () {
        memoryCache.set(handle, null);
        return null;
      })
      .finally(function () {
        pendingRequests.delete(handle);
      });

    pendingRequests.set(handle, request);
    return request;
  }

  function setProductCardImage(card, src) {
    if (!src) return;
    var image = card.querySelector('img.snize-item-image');
    if (!image) return;

    if (!image.dataset.rnrOriginalSrc) {
      image.dataset.rnrOriginalSrc = image.currentSrc || image.getAttribute('src') || '';
      image.dataset.rnrOriginalSrcset = image.getAttribute('srcset') || '';
    }

    image.removeAttribute('srcset');
    image.setAttribute('src', src);
  }

  function restoreProductCardImage(card) {
    var image = card.querySelector('img.snize-item-image');
    if (!image || !image.dataset.rnrOriginalSrc) return;

    image.setAttribute('src', image.dataset.rnrOriginalSrc);
    if (image.dataset.rnrOriginalSrcset) {
      image.setAttribute('srcset', image.dataset.rnrOriginalSrcset);
    } else {
      image.removeAttribute('srcset');
    }
  }

  function buildVariantUrl(baseUrl, variantId) {
    try {
      var url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return baseUrl + (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(variantId);
    }
  }

  function renderSwatches(card, data) {
    if (!data || !data.swatches || data.swatches.length < 2) return;

    var oldRow = card.querySelector('.rnr-snize-swatches');
    if (oldRow) oldRow.remove();

    var row = document.createElement('div');
    row.className = 'rnr-snize-swatches';
    row.setAttribute('role', 'list');
    row.setAttribute('aria-label', data.optionName + ' options');

    var productUrl = getProductUrl(card, data, data.handle);
    var visible = data.swatches.slice(0, MAX_VISIBLE_SWATCHES);

    visible.forEach(function (item) {
      var swatch = document.createElement('a');
      swatch.className = 'rnr-snize-swatch';
      if (item.value === data.selectedValue) swatch.classList.add('is-selected');
      swatch.href = buildVariantUrl(productUrl, item.variantId);
      swatch.title = data.optionName + ': ' + item.value;
      swatch.setAttribute('aria-label', data.optionName + ': ' + item.value);
      swatch.setAttribute('role', 'listitem');

      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 36;
        img.height = 36;
        img.loading = 'lazy';
        img.decoding = 'async';
        swatch.appendChild(img);

        swatch.addEventListener('mouseenter', function () {
          setProductCardImage(card, item.image);
        });
        swatch.addEventListener('focus', function () {
          setProductCardImage(card, item.image);
        });
      } else {
        var fallback = document.createElement('span');
        fallback.className = 'rnr-snize-swatch__fallback';
        fallback.textContent = item.value.slice(0, 2).toUpperCase();
        swatch.appendChild(fallback);
      }

      swatch.addEventListener('mouseleave', function () {
        restoreProductCardImage(card);
      });
      swatch.addEventListener('blur', function () {
        restoreProductCardImage(card);
      });

      row.appendChild(swatch);
    });

    if (data.swatches.length > MAX_VISIBLE_SWATCHES) {
      var more = document.createElement('a');
      more.className = 'rnr-snize-swatches__more';
      more.href = productUrl;
      more.textContent = '+' + (data.swatches.length - MAX_VISIBLE_SWATCHES);
      more.setAttribute('aria-label', 'View ' + (data.swatches.length - MAX_VISIBLE_SWATCHES) + ' more ' + data.optionName + ' options');
      more.setAttribute('role', 'listitem');
      row.appendChild(more);
    }

    var priceList = card.querySelector('.snize-price-list');
    if (priceList && priceList.parentNode) {
      priceList.insertAdjacentElement('afterend', row);
      return;
    }

    var title = card.querySelector('.snize-title');
    if (title && title.parentNode) {
      title.insertAdjacentElement('afterend', row);
      return;
    }

    card.appendChild(row);
  }

  function enhanceCard(card) {
    if (!card || card.nodeType !== 1) return;

    var handle = getProductHandle(card);
    if (!handle) return;

    if (card.dataset.rnrSwatchHandle === handle && card.querySelector('.rnr-snize-swatches')) return;

    card.dataset.rnrSwatchHandle = handle;
    var existing = card.querySelector('.rnr-snize-swatches');
    if (existing) existing.remove();

    loadProductSwatches(handle).then(function (data) {
      if (card.dataset.rnrSwatchHandle !== handle || !document.documentElement.contains(card)) return;
      renderSwatches(card, data);
    });
  }

  function scan(container) {
    var root = container && container.querySelectorAll ? container : document;
    var cards = root.matches && root.matches('.snize-product') ? [root] : root.querySelectorAll('.snize-product');
    Array.prototype.forEach.call(cards, enhanceCard);
  }

  function scheduleScan(container) {
    window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scan(container || document);
    }, 40);
  }

  function bindSearchaniseEvents() {
    if (!window.Searchanise || !window.Searchanise.$ || document.documentElement.dataset.rnrSnizeEventsBound === 'true') return;
    document.documentElement.dataset.rnrSnizeEventsBound = 'true';

    var $ = window.Searchanise.$;
    $(document).on('Searchanise.ResultsUpdated.rnrSwatches', function (event, container) {
      var element = container && container[0] ? container[0] : document;
      scheduleScan(element);
    });
  }

  function initObserver() {
    if (observer || !document.body) return;
    observer = new MutationObserver(function (mutations) {
      var shouldScan = mutations.some(function (mutation) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) return false;
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('.snize-product, .snize-search-results') || node.querySelector('.snize-product'));
        });
      });
      if (shouldScan) scheduleScan(document);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('Searchanise.Loaded', function () {
    bindSearchaniseEvents();
    scheduleScan(document);
  });

  function init() {
    bindSearchaniseEvents();
    initObserver();
    scheduleScan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
